/*
@format
 */
const replaceRules = [
    {
        description: 'Remove empty lines',
        matchRegExp: new RegExp('<p></p>', 'g'),
        replaceString: ''
    },
    {
        description: 'Replaces legacy <b> tags with <strong>',
        matchRegExp: new RegExp('<(/?)b>', 'g'),
        replaceString: '<$1strong>'
    },
    {
        description: 'Replaces legacy <i> tags with <em>',
        matchRegExp: new RegExp('<(/?)i>', 'g'),
        replaceString: '<$1em>'
    },
    {
        description: 'Convert headings to p',
        matchRegExp: /<(\/?)h\d>/g,
        replaceString: '<$1p>'
    }
];

export default function scrubHtml(html) {
    let result = html;
    replaceRules.forEach((rule) => (result = result.replace(rule.matchRegExp, rule.replaceString)));
    return result;
}